export const stringToFloat = (
  numberString: string | number,
  opts?: { allowNegative?: boolean }
) => {
  const { allowNegative = false } = opts || {};
  const regex = allowNegative ? /[^\d-]/g : /[^\d]/g;
  return parseFloat(String(numberString).replace(regex, ""));
};

export const strToNumericStr = (numericString: string) => {
  return String(numericString).replace(/[^\d]/g, "");
};
